module.exports = __webpack_public_path__ + "img/volume_off-24px.b6f3fa3b.svg";